import { render, staticRenderFns } from "./scope24.vue?vue&type=template&id=50d1205a&scoped=true"
import script from "./scope24.vue?vue&type=script&lang=js"
export * from "./scope24.vue?vue&type=script&lang=js"
import style0 from "./scope24.vue?vue&type=style&index=0&id=50d1205a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d1205a",
  null
  
)

export default component.exports